import nextDay from "../nextDay/index.js";
import requiredArgs from "../_lib/requiredArgs/index.js";
/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the next Saturday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */
export default function nextSaturday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 6);
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/nextSaturday/index.js
// module id = ./node_modules/date-fns/esm/nextSaturday/index.js
// module chunks = 1